export default [
  {
    "id": "newsSection-1",
    "plugin": "NewPromo",
    "pluginId": 1,
    "name": null,
    "html": require('./newsSections/newsSection-1/html').default,
    "scss": require('./newsSections/newsSection-1/scss').default,
    "scssTablet": require('./newsSections/newsSection-1/scssTablet').default,
    "scssMobile": require('./newsSections/newsSection-1/scssMobile').default,
    "css": require('./newsSections/newsSection-1/css').default,
    "cssTablet": require('./newsSections/newsSection-1/cssTablet').default,
    "cssMobile": require('./newsSections/newsSection-1/cssMobile').default,
    "js": require('./newsSections/newsSection-1/js').default,
    "minJs": require('./newsSections/newsSection-1/minJs').default,
    "userFriendlyName": [
      "promotion",
      "new-product",
      "most-viewed",
      "top-sellers",
      "cross-seling",
      "product-from-nls",
      "rec-products",
      "product-sale",
      "product-extra-qty",
      "product-extra-pr",
      "best-rated",
      "product-slr-rcmd",
      "product-announce",
      "suggested-products",
      "reward",
      "rec-manual-select",
      "rec-categories",
      "rec-producer",
      "rec-brand",
      "rec-recently-viewed"
    ],
	  "showOptions": true,
	  "config": '{"Image": true, "TotalItems": 15, "Type": "<type>", "IncludeGroup": true}',
    "svgContent": require('./newsSections/newsSection-1/svgContent').default,
    "svgViewBox": "0 0 1440 581",
    "svgContentMobile": require('./newsSections/newsSection-1/svgContentMobile').default,
    "svgViewBoxMobile": "0 0 360 502"
  }
]